/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerBulkDeleteMutationRequest, TasksControllerBulkDeleteMutationResponse, TasksControllerBulkDelete400, TasksControllerBulkDelete401 } from "../../models/tasksController/TasksControllerBulkDelete";

function getTasksControllerBulkDeleteUrl() {
  const res = { method: 'DELETE', url: `/api/v1/tasks/bulk` as const }  
  return res
}

/**
 * @description Soft-delete multiple tasks in one call. Supports partial success — failed items are reported per-item without blocking others. Returns 200 if all items succeed, 207 Multi-Status if any fail.
 * @summary Bulk delete tasks
 * {@link /api/v1/tasks/bulk}
 */
export async function tasksControllerBulkDelete(data: TasksControllerBulkDeleteMutationRequest, config: Partial<RequestConfig<TasksControllerBulkDeleteMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TasksControllerBulkDeleteMutationResponse, ResponseErrorConfig<TasksControllerBulkDelete400 | TasksControllerBulkDelete401>, TasksControllerBulkDeleteMutationRequest>({ method : "DELETE", url : getTasksControllerBulkDeleteUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}